<template>
  <card class="parc-profile-parc-date mb-2" title="Dates clefs du parc initial">
    <hr class="mt-1 mb-2" />
    <div>
      <p
        v-if="isDeclaration"
        :class="{
          'empty-field': !parc.dateDelivranceRecipissePrefecture
        }"
      >
        Délivrance du récépissé de déclaration par la préfecture
        <i v-if="parc.dateDelivranceRecipissePrefecture">{{
          $filters.formatDate(parc.dateDelivranceRecipissePrefecture)
        }}</i>
        <i v-else>{{ emptyField }}</i>
      </p>
      <p
        v-if="isAutorisation"
        :class="{
          'empty-field': !parc.dateDepotDemandeAutorisation
        }"
      >
        Dépôt du dossier de demande d'autorisation (ou du PC)
        <i v-if="parc.dateDepotDemandeAutorisation">{{
          $filters.formatDate(parc.dateDepotDemandeAutorisation)
        }}</i>
        <i v-else>{{ emptyField }}</i>
      </p>
      <p
        v-if="isAutorisation && !isRejet"
        :class="{
          'empty-field': !parc.dateDelivranceAvisAutoriteEnvironnementale
        }"
      >
        Délivrance de l'avis de l'autorité environnementale
        <i v-if="parc.dateDelivranceAvisAutoriteEnvironnementale">{{
          $filters.formatDate(parc.dateDelivranceAvisAutoriteEnvironnementale)
        }}</i>
        <i v-else>{{ emptyField }}</i>
      </p>
      <p
        v-if="isRejet"
        :class="{
          'empty-field': !parc.dateDelivranceRejet
        }"
      >
        Arrêté de rejet
        <i v-if="parc.dateDelivranceRejet">{{
          $filters.formatDate(parc.dateDelivranceRejet)
        }}</i>
        <i v-else>{{ emptyField }}</i>
      </p>
      <p
        v-if="isRefus"
        :class="{
          'empty-field': !parc.dateDelivranceRefus
        }"
      >
        Arrêté de refus
        <i v-if="parc.dateDelivranceRefus">{{
          $filters.formatDate(parc.dateDelivranceRefus)
        }}</i>
        <i v-else>{{ emptyField }}</i>
      </p>

      <div v-if="!isRefus && !isRejet">
        <p
          v-if="isAutorisation"
          :class="{
            'empty-field': !parc.dateDelivranceAutorisation
          }"
        >
          Arrêté d'autorisation ICPE
          <i v-if="parc.dateDelivranceAutorisation">{{
            $filters.formatDate(parc.dateDelivranceAutorisation)
          }}</i>
          <i v-else>{{ emptyField }}</i>
        </p>
        <p
          :class="{
            'empty-field': !parc.dateDebutConstruction
          }"
        >
          Déclaration d'ouverture du chantier de construction
          <i v-if="parc.dateDebutConstruction">{{
            $filters.formatDate(parc.dateDebutConstruction)
          }}</i>
          <i v-else>{{ emptyField }}</i>
        </p>
        <p
          :class="{
            'empty-field': !parc.dateMiseEnService
          }"
        >
          Mise en service
          <i v-if="parc.dateMiseEnService">{{
            $filters.formatDate(parc.dateMiseEnService)
          }}</i>
          <i v-else>{{ emptyField }}</i>
        </p>
        <p
          :class="{
            'empty-field': !parc.dateDebutDemantelement
          }"
        >
          Déclaration d’ouverture du chantier de démantèlement
          <i v-if="parc.dateDebutDemantelement">{{
            $filters.formatDate(parc.dateDebutDemantelement)
          }}</i>
          <i v-else>{{ emptyField }}</i>
        </p>
        <p
          v-if="parc.dateCessationActivite"
          :class="{
            'empty-field': !parc.dateCessationActivite
          }"
        >
          Cessation d'activité
          <i v-if="parc.dateCessationActivite">{{
            $filters.formatDate(parc.dateCessationActivite)
          }}</i>
          <i v-else>{{ emptyField }}</i>
        </p>
      </div>
    </div>
  </card>
</template>
<script>
import { mapGetters } from "vuex";
import { StatsCard } from "@/components/index";

export default {
  components: {
    StatsCard
  },
  data() {
    return {
      emptyField: "Non saisie"
    };
  },
  computed: {
    ...mapGetters({
      parc: "parc",
      isRejet: "isRejet",
      isRefus: "isRefus",
      isAutorisation: "isAutorisation",
      isDeclaration: "isDeclaration"
    })
  }
};
</script>
<style lang="scss">
.parc-profile-parc-date {
  &.card {
    .card-header {
      padding: 20px 14px 0;
    }
  }
  i {
    display: block;
    margin-top: 5px;
    margin-left: 1px;
  }
}
</style>
